import React, { useCallback } from 'react';
import styled from 'styled-components';
import { ListItem } from 'src/components/list-item';
import { layout } from 'src/components/base';

type Props = {
  filters: { id: string; title: string }[];
  setCurrentSectionId: (id: string) => void;
  getCallToActionText: (option: {
    id?: string;
    property?: string;
  }) => string | undefined;
};

export const SectionItems = (props: Props) => {
  const { filters, getCallToActionText, setCurrentSectionId } = props;

  const onClick = useCallback(
    (id: string) => setCurrentSectionId(id),
    [setCurrentSectionId]
  );

  return (
    <List>
      {filters.map(option => (
        <ListItem
          key={option.id}
          name={option.title}
          callToActionText={getCallToActionText(option)}
          showArrow
          onClick={() => onClick(option.id)}
          // disabled={disabled}
        />
      ))}
    </List>
  );
};

export const List = styled.div`
  padding: 0 ${layout.measurements.spacing050};
  width: 100%;
`;
